export default __webpack_public_path__ + "static/media/pythontest36.de4607d7.png";